window.EVASuit = window.EVASuit || {};
window.EVASuit.Behaviors = window.EVASuit.Behaviors || {};

window.EVASuit.Behaviors.Behavior = function(Element, Document, Behaviors) {
    "use strict";

    /**
     * Unique name for our list of located instances.
     */
    const LOCATED_INSTANCES = Symbol("locatedInstances");

    /**
     * A custom JavaScript behavior that can be repeatedly located onto a set
     * of elements named by a CSS selector.
     */
    class Behavior {
        /**
         * Find markup that this Behavior locates onto within a given context
         * and instantiate the class on that markup.
         * 
         * The current class's QUERY parameter will be used as the CSS selector
         * to find markup with. If the given context itself also matches the
         * selector, it 
         * 
         * @param {jQuery|Element} context The context element to find markup
         * in.
         * @param {...any} _ Any arguments to pass on down into the context.
         * 
         * Must either be shaped like a jQuery object or a DOM element.
         */
        static find_markup(context) {
            var results = [], i, splitArgs = [], Class = this, nodelist;

            function processElem(index, elem) {
                var locateArgs = [elem].concat(splitArgs);

                results.push(Class.locate.apply(Class, locateArgs));
            }

            for (i = 1; i < arguments.length; i += 1) {
                splitArgs.push(arguments[i]);
            }

            if (context instanceof Element || context instanceof Document) { //Element-like context
                nodelist = Array.prototype.slice.call(context.querySelectorAll(Class.QUERY));
                nodelist.forEach(element => {
                    processElem(undefined, element);
                });

                //Documents lack a matches method
                if (context.matches && context.matches(Class.QUERY)) {
                    processElem(undefined, context);
                }
            } else if (context.filter && context.find) { //jQuery-like context
                context.filter(Class.QUERY).each(processElem);
                context.find(Class.QUERY).each(processElem);
            } else {
                throw new Behaviors.ElementMissingError("Behavior.find_markup called without valid context object");
            }
        }
        
        /**
         * Instantiate this Behavior onto this element.
         * 
         * Behaviors are designed to locate onto a given element once and only
         * once. If it has already been instantiated, then that instance will
         * be returned again.
         * 
         * @param {jQuery|Element} elem The element to locate on.
         * 
         * May either be a DOM element or jQuery.
         * 
         * @param {...any} objectArgs Any other arguments to pass to the
         * behavior's constructor.
         * 
         * @returns An instance of the Behavior on this element.
         * 
         * @throws ElementMissingError if the element is neither jQuery nor a
         * DOM element, or if it's jQuery but has a length of 0.
         */
        static locate(elem, ...objectArgs) {
            var Class = this, instance;

            if (elem instanceof Element || elem instanceof Document) { //Element-like element
                if (Class[LOCATED_INSTANCES] === undefined) {
                    Class[LOCATED_INSTANCES] = new WeakMap();
                }

                if (!Class[LOCATED_INSTANCES].has(elem)) {
                    Class[LOCATED_INSTANCES].set(elem, new Class(elem, ...objectArgs));
                }

                return Class[LOCATED_INSTANCES].get(elem);
            } else if (elem.length !== undefined && elem.length > 0) { //jQuery-like element
                return self.locate(elem[0], ...objectArgs);
            } else {
                throw new Behaviors.ElementMissingError("Behavior.locate called without valid element");
            }
        }

        /**
         * Indicates to the class that content was added to the page.
         * 
         * Subclasses that override this function MUST call find_markup on the
         * full context eventually. You may use this function to delay Behavior
         * processing until a later time, but your Behavior must still be able
         * to handle code locating it before that time.
         * 
         * @param {jQuery|Element} context The content that was added to the DOM.
         */
        static content_ready(context) {
            this.find_markup(context);
        }

        /**
         * Indicates to the class that content is about to be removed from the
         * page.
         * 
         * Most Behaviors do not need to worry about content removal; garbage
         * collection will detach any event handlers and reclaim your object as
         * needed. However, things such as animation timers or other global
         * references to the object will keep it live and potentially leak
         * memory or keep rendering things off-screen. Content removal
         * notifications allow tearing down and disposing of such semantic
         * garbage.
         * 
         * Subclasses that need to support tear down upon removal should
         * override the instance method `deinitialize` instead.
         * 
         * @param {jQuery|Element} context The content that was removed from
         * the DOM.
         */
        static content_removal(context) {
            var Class = this, nodelist;

            function deinitialize_elem(elem) {
                var instance = Class.locate(elem);

                instance.deinitialize();
            }

            if (context instanceof Element) { //DOM contexts
                nodelist = Array.prototype.slice.call(context.querySelectorAll(Class.QUERY));
                nodelist.forEach(deinitialize_elem);

                if (context.matches(Class.QUERY)) {
                    deinitialize_elem(elem);
                }
            } else if (context.filter && context.find) { //jQuery-like context
                context.filter(Class.QUERY).each((index, elem) => deinitialize_elem(elem));
                context.find(Class.QUERY).each((index, elem) => deinitialize_elem(elem));
            } else {
                throw new Behaviors.ElementMissingError("Behavior.content_removal called without valid context object");
            }
        }

        /**
         * Construct a new instance of this Behavior.
         * 
         * The given element will be stored in this.elem. If jQuery is loaded,
         * a wrapped jQuery object with the element will be stored in
         * this.$elem.
         * 
         * @param {Element} elem The DOM element being located upon.
         */
        constructor(elem) {
            this.elem = elem;

            if (window.jQuery) {
                this.$elem = window.jQuery(elem);
            }
        }

        /**
         * Tear down any animation timers or other global references to this
         * Behavior.
         */
        deinitialize() {

        }

        /**
         * Called when the Behavior is presented to the user.
         * 
         * Should not be called to programmatically present a Behavior. To do
         * so, call Behaviors.present.
         */
        presented() {

        }

        /**
         * Called when the Behavior is dismissed.
         * 
         * Should not be called to programmatically dismiss a Behavior. To do
         * so, call Behaviors.dismiss.
         */
        dismissed() {

        }
    }

    return Behavior;
}(window.Element, window.Document, window.EVASuit.Behaviors);